import React, {useEffect} from "react";

export default function AuthOverlay({children, onClose, className}) {


  return (
    <div
      className={`
          auth-login-modal-overlay
          fixed inset-0
          bg-[rgba(1,5,31,0.7)]
          backdrop-blur-[24px]
          flex items-center justify-center
          z-[2000]
          overflow-y-auto
          py-10
          ${className || ""}
        `}
      onClick={onClose}
    >
      {/* блокируем клик по фону */}
      <div className="justify-items-center" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}